export function timeAgo(timestamp) {
  const date = new Date(timestamp);
  const ms = new Date().getTime() - date.getTime();
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  if (ms === 0) {
    return "Just now";
  }

  if (seconds < 60) {
    return `${seconds} second${seconds === 1 ? "" : "s"} ago`;
  }

  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  if (hours < 24) {
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  if (days < 30) {
    return `${days} day${days === 1 ? "" : "s"} ago`;
  }

  if (months < 12) {
    return `${months} month${months === 1 ? "" : "s"} ago`;
  }
  return `${years} year${years === 1 ? "" : "s"} ago`;
}

export function stripTags(str) {
  return str?.replace(/<[^>]*>/g, "");
}

export function addReplyBox(replyBox) {
  document.querySelectorAll(".reply-box").forEach((el) => {
    el.classList.remove("show");
  });
  replyBox.classList.add("show");
  replyBox.querySelector(".pell-content").focus();
}

export function removeReplyBox(replyBox) {
  document.querySelectorAll(".reply-box").forEach((el) => {
    el.classList.remove("show");
  });
  replyBox.classList.remove("show");
  replyBox.querySelector(".pell-content").blur();
}

export function addNoScroll() {
  document.body.classList.add("no-scroll");
}

export function removeNoScroll() {
  document.body.classList.remove("no-scroll");
}

export function addOverlay() {
  document.getElementById("mobile-overlay").classList.add("active-in-mobile");
  document.body.classList.add("no-scroll");
}

export function removeOverlay() {
  document.body.classList.remove("no-scroll");
  document.querySelectorAll(".react-icons-wrapper").forEach((el) => {
    el.classList.remove("show-action");
  });
  document.querySelectorAll(".share-icons-wrapper").forEach((el) => {
    el.classList.remove("show-action");
  });
  document.querySelectorAll(".right-menu").forEach((el) => {
    el.classList.remove("show-modal-now", "show-right-menu");
  });
  document
    .getElementById("mobile-overlay")
    .classList.remove("active-in-mobile");
}

export function addContextMenu(event = null) {
  console.log(event);
  document.querySelectorAll(".right-menu").forEach((el) => {
    el.classList.add("show-right-menu", "show-modal-now");
  });
  addOverlay();
  if (event) {
    event.currentTarget.classList.add("show-right-menu", "show-modal-now");
  }
}

export function removeContextMenu(event = null) {
  setTimeout(() => {
    document.querySelectorAll(".right-menu").forEach((el) => {
      el.classList.remove("show-right-menu", "show-modal-now");
    });
    removeOverlay();
    if (event) {
      event.currentTarget.classList.remove("show-right-menu", "show-modal-now");
    }
  }, 1);
}

export function reactionsCount(object) {
  let count = 0;

  if (object?.love) {
    count += object?.love.length;
  }

  if (object?.clap) {
    count += object?.clap.length;
  }

  if (object?.like) {
    count += object?.like.length;
  }

  if (object?.dislike) {
    count += object?.dislike.length;
  }

  return count;
}

export function clearInput(ref) {
  if (ref) {
    ref.querySelector(".pell-content").innerHTML = "";
  }
}

export function disablePellEditor(ref) {
  if (ref) {
    ref.querySelector(".pell-content").setAttribute("contenteditable", "false");
  }
}

export function enablePellEditor(ref) {
  if (ref) {
    ref.querySelector(".pell-content").setAttribute("contenteditable", "true");
  }
}

export function parseJWT(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}
